import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { API_V3_URL } from 'src/app/config/config';
import { documentItem } from 'src/app/models/document.model';
import { LanguageService } from '../language/language.service';
import { ApiCallBase } from './apiCallBase';

@Injectable({
  providedIn: 'root',
})
export class GeneralDocsService extends ApiCallBase {
  constructor(
    public languageService: LanguageService,
    public http: HttpClient,
    public router: Router,
  ) {
    super(languageService, http, router);
    this.language =
      this.language === 'es'
        ? 'ES-LA'
        : this.language === 'en'
          ? 'EN-US'
          : this.language;
  }

  getGeneralDocuments(language: string): Observable<documentItem[]> {
    const url = `${API_V3_URL}/portal/get-files?user_id=${this.userId}&category=GENERAL_DOCS&language=${this.language}`;

    return this.http.get<documentItem[]>(url, this.getHttpOptionsV3());
  }
}
